import Api from '@/api/api'

export default {
    getUnassignedEmp(faceId) {
        return Api.get('org/Team/GetUnassignedEmployee/?FacilityID=' + faceId)
    },

    getTeamInfo(id, faceId) {
        return Api.get('org/Team/GetTeamInfo/' + id + '/?FacilityID=' + faceId)
    },
    saveTeam(data) {
        return Api.put('org/Team/SaveTeam/', data)
    },
    getUnassignedEmpId(id, faceId) {
        return Api.get('org/Team/GetUnassignedEmployeeByTeamId/' + id + '/?FacilityID=' + faceId)
    },
    getTeam(faceId) {
        return Api.get('org/Team/GetTeams/?FacilityID=' + faceId)

    },
    getEmpByUser() {
        return Api.get('org/Employee/GetEmployeeFromCurrentUser')
    },
    deleteTeam(id) {
        return Api.delete(`org/Team/DeleteTeam/${id}`)
    }
}